import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseFormInput = _resolveComponent("BaseFormInput")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("form", {
    class: _normalizeClass(["FormGetStarted main-started-form", { 'is--hidden-input': _ctx.isLoggedIn }]),
    novalidate: ""
  }, [
    _createVNode(_component_BaseFormInput, {
      modelValue: _ctx.email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
      class: "input main-started-form__input",
      type: "email",
      placeholder: "Email Address"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_BaseButton, {
      type: "submit",
      class: "main-started-form__button",
      color: "primary",
      large: "",
      onClick: _withModifiers(_ctx.onSubmit, ["prevent"])
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode(" Get Started ")
      ])),
      _: 1
    }, 8, ["onClick"])
  ], 2))
}